export function triggerDownload(dataUri, filename) {
    const element = document.createElement("a");
    element.setAttribute("href", dataUri);
    element.setAttribute("download", filename);
    document.body.appendChild(element);
    // onClick property
    element.click();
    document.body.removeChild(element);
}
/*
  Simply using atob doesn't work for decoding base64 strings in the browser with UTF8.
  This function is a workaround for that.
 */
export function decodeBase64(base64) {
    const text = atob(base64);
    const length = text.length;
    const bytes = new Uint8Array(length);
    for (let i = 0; i < length; i++) {
        bytes[i] = text.charCodeAt(i);
    }
    const decoder = new TextDecoder(); // default is utf-8
    return decoder.decode(bytes);
}
/**
 * The payload half of a `data:<mime>;base64,<payload>` URL.
 *
 * `FileReader.readAsDataURL` always produces that shape and always resolves to a
 * string, so neither branch below is reachable for a file read that way — they
 * throw rather than fall back so a reader that produced something else is loud
 * instead of handing on an empty payload.
 */
export function base64PayloadOf(dataUrl) {
    if (typeof dataUrl !== "string") {
        throw new Error("File was not read as a data URL");
    }
    const payload = dataUrl.split(",")[1];
    if (payload === undefined) {
        throw new Error("File is not a base64 data URL");
    }
    return payload;
}
export function blobToBase64(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        // Success handler
        reader.onload = () => {
            const base64 = reader.result;
            if (typeof base64 === "string") {
                resolve(base64);
            }
            else {
                // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
                reject("Failed to convert blob to base64");
            }
        };
        // Failure handler
        reader.onerror = () => {
            // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
            reject("Failed to convert blob to base64");
        };
        reader.readAsDataURL(blob);
    });
}
//# sourceMappingURL=util.js.map